import * as React from "react";
import { getCssProperties } from "./transform-area";

export const HighlightRect = ({ area, rotation }) => (
    <div className="rpv-highlight__selected-text" style={getCssProperties(area, rotation)} />
);
